// extracted by mini-css-extract-plugin
module.exports = {"scroll_to_bottom":"conversation-items-list-view-scroll_to_bottom__3UU_j","observer":"conversation-items-list-view-observer__1KSP-"};